{
  "SEARCH": {
    "TABS": {
      "ALL": "الكل",
      "CONTACTS": "جهات الاتصال",
      "CONVERSATIONS": "المحادثات",
      "MESSAGES": "الرسائل"
    },
    "SECTION": {
      "CONTACTS": "جهات الاتصال",
      "CONVERSATIONS": "المحادثات",
      "MESSAGES": "الرسائل"
    },
    "VIEW_MORE": "View more",
    "LOAD_MORE": "Load more",
    "SEARCHING_DATA": "جاري البحث",
    "LOADING_DATA": "جار التحميل",
    "EMPTY_STATE": "لم يتم العثور على {item} للطلب '{query}'",
    "EMPTY_STATE_FULL": "لم يتم العثور على نتائج للطلب '{query}'",
    "PLACEHOLDER_KEYBINDING": "/ للتركيز",
    "INPUT_PLACEHOLDER": "أكتب 3 أحرف أو أكثر للبحث",
    "RECENT_MESSAGES": "رسائلي المُرسلة مؤخرًا",
    "EMPTY_STATE_DEFAULT": "البحث عن طريق معرف المحادثة أو البريد الإلكتروني أو رقم الهاتف أو الرسائل للحصول على نتائج بحث أفضل. ",
    "BOT_LABEL": "رد آلي",
    "READ_MORE": "اقرأ المزيد",
    "WROTE": "كتب:",
    "FROM": "من",
    "EMAIL": "البريد الإلكتروني",
    "EMAIL_SUBJECT": "الموضوع"
  }
}
